'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const LoyaltyCardIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.25 5.52502H3.75C3.19772 5.52502 2.75 5.97274 2.75 6.52502V17.475C2.75 18.0273 3.19772 18.475 3.75 18.475H20.25C20.8023 18.475 21.25 18.0273 21.25 17.475V6.52502C21.25 5.97274 20.8023 5.52502 20.25 5.52502Z",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.05 10.295C14.58 10.295 11.5 12.855 11.5 14.975C11.5 16.075 12.34 16.625 13.45 16.625C14.27 16.625 15.25 16.325 16.21 15.755V11.515C15.96 11.955 14.76 13.705 13.8 14.635C13.31 15.115 12.92 15.315 12.59 15.315C12.22 15.315 12.04 15.065 12.04 14.685C12.04 12.965 14.93 10.735 16.84 10.735C17.63 10.735 18.14 11.085 18.14 11.765C18.14 12.385 17.72 13.165 17 13.895V15.205C18.26 14.215 19.01 12.945 19.01 11.915C19.01 10.835 18.17 10.285 17.06 10.285L17.05 10.295Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpLoyaltyCardIcon = forwardRef(LoyaltyCardIcon);

export { VpLoyaltyCardIcon as default };
